import { MessageTemplate } from 'src/constants/types';
import { useBuilderMessageTemplates } from '../context';

/**
 * The company's active message templates.
 *
 * MessagesField and TextToWinSettingsField each ran this exact request with the
 * same params and the same company filter: active templates only, then filtered
 * to this company so shared/global rows do not leak in.
 *
 * `null` means the request has not settled, and a caller must not mount an
 * editor before it does. TemplateText builds its TipTap extensions once, with no
 * dependency array, so the template list handed to it on mount is the one it
 * keeps: mount early and "Insert Template" stays empty for the rest of the
 * session however late the templates arrive. A failed request resolves to an
 * empty list rather than staying null, so the editor still opens without them.
 */
export function useMessageTemplates(): MessageTemplate[] | null {
  return useBuilderMessageTemplates();
}
